'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createSpacing = {};

exports.__exports = createSpacing;
